// extracted by mini-css-extract-plugin
export default {"root":"fOLL_JAO","chartContainer":"bc5NYTxD","infoContainer":"Trn2B01B","buttonNotes":"Uf3ZcPUb","cardsContainer":"DctPy_cn","title":"Z0MSAod_","value":"Mb_x2mrm"};